import gql from 'graphql-tag';
import { query } from '../../client';
import { ADDRESS_FIELDS } from '../fragments/addressFields';
import { PROFILE_FIELDS } from '../fragments/profileFields';
export const PROFILE = gql `
  ${ADDRESS_FIELDS}
  ${PROFILE_FIELDS}

  query ProfilesQuery($searchInput: String!) {
    profiles(searchInput: $searchInput) @rest(type: "ProfileResult", path: "internal/users/query?filter={args.searchInput}") {
      data @type(name: "Profile") {
        ...ProfileFields
        address @type(name: "Address") {
          ...AddressFields
        }
        createdAt
        updatedAt
      }
    }
  }
`;
// Query profile from OMNI.
export function getProfile(memberId, accountId) {
    const idPartial = accountId ? `"externalId": "${accountId}"` : `"membershipId": "${memberId}"`;
    return query({
        query: PROFILE,
        variables: {
            searchInput: `{"skip":0,"limit":25,"order":"createdAt DESC","where":{"and":{${idPartial},"createdAt":{"neq":null}}}}`,
        },
    });
}
